
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PenSquare, BookOpen, Plus } from 'lucide-react';
import { toast } from '@/components/ui/use-toast';

interface MobileMenuProps {
  isOpen: boolean;
  isInReaderMode: boolean;
  isJournalist: boolean;
  children: React.ReactNode;
  onClose?: () => void;
}

const MobileMenu = ({ isOpen, isInReaderMode, isJournalist, children, onClose }: MobileMenuProps) => {
  const navigate = useNavigate();
  
  if (!isOpen) return null;

  const handleSwitchMode = () => {
    if (isInReaderMode) {
      console.log('MobileMenu - Switching to Creator mode');
      navigate('/dashboard');
      toast({
        title: "Creator Mode",
        description: "You're now in Creator mode"
      });
    } else {
      console.log('MobileMenu - Switching to Reader mode');
      navigate('/home');
      toast({
        title: "Reader Mode", 
        description: "You're now in Reader mode"
      });
    }
    
    // Close mobile menu after switching
    if (onClose) onClose();
  };

  return (
    <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-[#F0F5F5] shadow-md z-40 animate-fade-in">
      <nav className="flex flex-col px-4 py-4">
        {children}
        
        {isJournalist && (
          <>
            <button 
              onClick={handleSwitchMode}
              className="flex items-center gap-2 mt-4 border-t pt-4 text-primary cursor-pointer"
            >
              {isInReaderMode ? (
                <>
                  <PenSquare size={16} />
                  <span>Switch to Creator</span>
                </>
              ) : (
                <>
                  <BookOpen size={16} />
                  <span>Switch to Reader</span>
                </>
              )}
            </button>
          </>
        )}
        
        {isJournalist && (
          <Link 
            to="/dashboard/editor/new"
            className="flex items-center gap-2 mt-4 text-white bg-directpress-orange hover:bg-orange-600 py-2 px-4 rounded-md"
            onClick={onClose}
          >
            <Plus size={16} />
            <span>New Article</span>
          </Link>
        )}
      </nav>
    </div>
  );
};

export default MobileMenu;
